'use strict';

var cov_2flffqrq2e = function () {
  var path = '/Users/mxu/code/uport-connect/src/index.js',
      hash = 'ca2e0df00ad8b9ae8d2f6a2306924cac8eedfde2',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/mxu/code/uport-connect/src/index.js',
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UportSubprovider = exports.Connect = undefined;

var _Connect = require('./Connect');

var _Connect2 = _interopRequireDefault(_Connect);

var _UportSubprovider = require('./UportSubprovider');

var _UportSubprovider2 = _interopRequireDefault(_UportSubprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Connect = _Connect2.default;
exports.UportSubprovider = _UportSubprovider2.default;


//////////////////
// WEBPACK FOOTER
// ./~/uport-connect/lib/index.js
// module id = 902
// module chunks = 0